<script>
/* eslint-disable no-empty */
/* eslint-disable no-undef */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable vue/no-unused-components */
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Swal from "sweetalert2";

import PopupDetail from "./popup-detail";

import DatePicker from "vue2-datepicker";
import Switches from "vue-switches";
import Multiselect from "vue-multiselect";
import HotelDatePicker from "vue-hotel-datepicker";
import NumberInputSpinner from "vue-number-input-spinner";
import moment from "moment";
import { icons } from "../data-fontawesome";
import { urlMethods } from "@/state/helpers";

export default {
  page: {
    title: "Tra cứu đơn sàn thương mại",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    HotelDatePicker,
    DatePicker,
    Switches,
    Multiselect,
    NumberInputSpinner,
    PopupDetail,
  },
  data() {
    return {
      title: "Tra cứu đơn sàn thương mại",
      icons: icons,
      totalRows: 0,
      currentPage: 1,
      orderfilterOn: [],
      orders: [],
      orderFilter: null,
      startDate: "01/01/2017",
      endDate: moment().format("DD/MM/YYYY"),
      isLoading: false,
      dateRange: [new Date("2017-01-01"), new Date()],
      statusSelected: [{ id: "all", name: "Tất cả trạng thái" }],
      storeSelected: [{ id: "all", name: "Tất cả siêu thị" }],
      posSelected: [{ id: "all", name: "Tất cả điểm bán lẻ" }],
      optionStatus: [
        { id: "all", name: "Tất cả trạng thái" },
        { id: "draft", name: "Mới" },
        { id: "recovery", name: "Nhập hàng thu hồi" },
        { id: "invoiced", name: "Đã xuất hoá đơn" },
        { id: "cancel", name: "Đã huỷ" },
      ],
      optionStore: [],
      optionPos: [],
      loadingArr: [],
      searchText: "",
      fields: [
        "id",
        {
          key: "name",
          label: "Mã đơn hàng",
        },
        {
          key: "shipment_id",
          label: "Mã đơn sàn",
        },
        {
          key: "shipment_code",
          label: "Mã vận đơn",
        },
        {
          key: "customer_name",
          label: "Khách hàng",
        },
        {
          key: "total",
          label: "Tổng tiền",
          formatter: (value) => {
            if (typeof value == "undefined" || value == null) return 0;
            return parseFloat(value).toLocaleString() + " ₫";
          },
        },
      ],
      orderDetail: null,
      orderLines: null,
    };
  },
  computed: {
    currentUser() {
      let user = localStorage.getItem("currentUser") || false;
      return user ? JSON.parse(user) : false;
    },
    windowWidth() {
      return window.innerWidth;
    },
  },
  methods: {
    ...urlMethods,

    searchOrder() {
      let that = this;
      that.currentPage = 1;
      that.getOrders();
    },

    changePage() {
      let that = this;
      that.getOrders();
    },

    async getOrderStep2() {
      let that = this;
      let body = {
        s: that.searchText,
        page: that.currentPage,
      };
      try {
        let res = await that.postUrl({
          url: "order-ecommerce-platform",
          data: body,
        });
        that.orders = res.data;
        that.totalRows = res.total;
        that.isLoading = false;
      } catch (error) {
        that.orders = [];
        that.totalRows = 0;
        that.isLoading = false;
        let text = typeof error == "string" ? error : JSON.stringify(error);
        this.$store.dispatch("sale/setNoti", { text: text, type: "error" });
      }
    },

    removeLoading(_id = 0) {
      let that = this;
      that.loadingArr = that.loadingArr.filter(function(item) {
        return item != _id;
      });
    },

    loadingOrder(id = 0) {
      let that = this;
      return that.loadingArr.includes(id);
    },

    async getOrders() {
      let that = this;
      that.isLoading = true;
      setTimeout(async () => {
        await that.getOrderStep2();
      }, 0);
    },

    async showPopupOrderDetail(order) {
      let that = this;

      // -- Get detail order by id
      let res = await that.getUrl(`order-ecommerce-platform/${order.id}`);
      if (res.data) {
        that.orderDetail = res.data;
      } else {
        that.orderDetail = order;
      }

      // -- Get order lines
      let resOrderLine = await that.getUrl(
        `order-ecommerce-platform-products/${order.id}`
      );
      if (resOrderLine.data) {
        that.orderLines = resOrderLine.data;
      }

      // -- Show so order detail
      this.$bvModal.show("modal-so-detail");
    },
  },
  mounted() {
    this.getOrders();
  },
};
</script>

<template>
  <div>
    <Layout>
      <div class="card">
        <div class="card-body pb-0">
          <!-- Filter -->
          <div class="filter-box">
            <div class="filter-item filter-item-ecommerce">
              <div
                class="search-box search-box-ecommerce  me-2 mb-0 d-inline-block"
              >
                <div class="position-relative">
                  <input
                    type="text"
                    class="form-control"
                    v-model="searchText"
                    v-on:keyup.enter="searchOrder"
                    placeholder="Tìm theo SDT khách, mã đơn sàn, mã SO, mã vận đơn"
                  />
                  <i class="bx bx-search-alt search-icon"></i>
                </div>
              </div>
            </div>
          </div>
          <!-- ./ Filter -->

          <!-- List orders on ecommerce platform -->
          <div
            class="table-responsive"
            style="padding: 0px 0px 15px"
            v-if="orders.length > 0"
          >
            <b-table
              id="my-table"
              class="p-0 m-0 table-striped table-bordered"
              striped
              hover
              :items="orders"
              :fields="fields"
            >
              <template v-slot:cell(name)="data">
                <a href="#" @click="showPopupOrderDetail(data.item)">
                  {{ data.item.name }}
                </a>
              </template>

              <template v-slot:cell(status)="data">
                <span
                  :class="'badge font-size-12 bg-' + data.item.status_class"
                  >{{ data.item.status_name }}</span
                >
              </template>
            </b-table>
          </div>
          <!-- ./ List orders on ecommerce platform -->

          <!-- Panigation -->
          <div class="row" style="padding-bottom: 15px;" v-if="totalRows > 30">
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0">
                  <b-pagination
                    aria-controls="my-table"
                    @change="changePage"
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="50"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
          <!-- ./ Panigation -->
        </div>
      </div>
    </Layout>
    <popup-detail
      :orderDetail="orderDetail"
      :orderLines="orderLines"
    ></popup-detail>
  </div>
</template>
